import './App.css';
import { Route, Routes } from 'react-router';
import Home from './Screens/Home-Screen/Home';
import Guard from './Routing/Guard';
import Login from './Screens/Login-Screen/Login';
import Store from './Redux';
import { Provider } from 'react-redux';
import { useEffect } from 'react';
import Usage from './Screens/Usage-screen/USage';
import Toast from './Utils/Toast/toast-component';
import SignUp from './Screens/SignUp-Screen/SignUp';
import Editor from './Screens/Editor-Screen/Editor-screen';
import Landing from './Screens/Landing-screen/Landing';
import Profile from './Screens/Profile-screen/Profile';
import ResetPassword from './Screens/ResetPassword-Screen/ResetPassword';
import Contact from './Screens/Contact-screen/Contact';
import CommingSoon from './Screens/Error-Screen/Commingsoon-screen';
import NotFound from './Screens/Error-Screen/NotFound-screen';
import Courses from './Screens/Courses-screen/Courses';
import Poll from './Screens/Poll-Screen/Poll';
import Privacy from './Screens/Privacy-screen/Privacy';
import Terms from './Screens/Terms-screen/Terms';

function App() {
  useEffect(() => {
    window.Cookiebot.show();
    console.log(`
    ▄█████▄_  ,▄█████▄    ███   ▐██⌐ Φ██████▄   ▄██████  ▄██████  ███    ███   ,██M
    ███╙'╙▀  ███▀   ╙███  ███   ▐██⌐  ''''╙███ ╫██▄ ╙" ▐██▌  "╙  ███     ▀██,▄██Γ
   ▐██       ▐██▌    _██▌ ███   ▐██⌐ ╓▄▄▄▄▄███  ▀█████▄  ▀██████_ ███      ╙████
    ███▄_,▄█_ ███▄,_▄███  ╟██▄_,███  ╫██▀▀██▌   ▄,__▄██▌ ▄▄__▄███ ███,,,,_  ╟██
    ╙▀▀██▀▀    '▀▀██▀▀╙    ╙▀███▀▀   ╚▀▀   ▀▀▀ ╙▀▀███▀╙ ^▀▀███▀▀  ▀▀▀▀▀▀▀▌  ╚▀▀
`);


  }, []);

  return (
    <Provider store={Store}>
      <Toast />
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/login" element={<Landing />} />
          <Route path="/home" element={<Landing />} />
          <Route path="/resetpswd" element={<ResetPassword />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/poll" element={<Poll />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path='/*' element={<NotFound />} />


          {/* <Route element={<Guard />}>
            <Route path="/usage" element={<Usage />} />
            <Route path="/reciploai" element={<Courses />} />
            <Route path="/account" element={<CommingSoon />} />
            <Route path="/profile" element={< Profile />} />

          </Route> */}
        </Routes>
      </div >
    </Provider>
  );
}

export default App;
